import { CIPHER_PREFIX } from './cipher-format';
export const isCipher = (value) => typeof value === 'string' && value.startsWith(CIPHER_PREFIX);
